import { h } from 'preact';
import { clsx } from 'clsx';
import PromoBarSlider from './promo-bar-slider';
import { useWindowSize } from '../utils/window-size';

const PromoBar = ({ data, promoBarRef }) => {
  const { isMobile, isTablet } = useWindowSize();
  const hasPromoMessages = data?.promo_bar?.length > 0;
  // eslint-disable-next-line max-len
  const filteredPromoMessages = data?.promo_bar?.filter((item) => item?.market === window.TMW.localization.countryCode.toLowerCase());

  return (
    <div
      ref={promoBarRef}
      className={clsx(
        (isMobile || isTablet) && !hasPromoMessages ? 'h-0' : 'h-[35px]',
        'laptop:h-[45px] overflow-hidden utility-2 laptop:utility-1 w-full flex items-center',
      )}
      style={{
        background: data.promo_bar_colors.background,
        color: data.promo_bar_colors.color,
      }}
    >
      <PromoBarSlider
        slides={filteredPromoMessages}
        rotationSpeed={data.promo_bar_rotation_speed}
      />

      <div className="hidden laptop:flex">
        {data.showPromoBarLink && data.promoBarLink
        && data.promoBarLinkText && (
          <a
            href={data.promoBarLink}
            className="whitespace-nowrap inline-flex min-w-[118px] px-[19px] justify-center items-center border-l border-[#7B7B7B] pt-[17px] pb-[14px]"
          >
            {data.promoBarLinkText}
          </a>
        )}
        <a
          href={data.locatorUrl || '#'}
          className="whitespace-nowrap inline-flex min-w-[118px] px-[19px] justify-center items-center border-l border-[#7B7B7B] pt-[17px] pb-[14px]"
        >
          {window.TMW?.Strings?.header?.storeLocator}
        </a>
        <a
          href={
            data.customer?.name
              ? `${window.Shopify.routes.root}account`
              : `${window.Shopify.routes.root}account/login`
          }
          className="whitespace-nowrap inline-flex min-w-[118px] px-[19px] justify-center items-center  border-l border-[#7B7B7B] pt-[17px] pb-[14px]"
        >
          {data.customer?.name || window.TMW?.Strings?.header?.login}
        </a>
      </div>
    </div>
  );
};

export default PromoBar;
